<template>
    <v-row class="pa-4" no-gutters>
        <v-col cols="8">
            <v-row no-gutters>
                <v-col cols="6" class="pa-2">
                    <!-- Etats des tâches récurrentes -->
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>&#xc9;tats des t&#xe2;ches récurrentes</v-card-title>
                        <v-card-text>
                            <p class="text--primary">Dossiers actifs</p>
                            <div class="text-h4 text--primary">3 780</div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pa-2">
                    <!-- <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Dernier millésime de la liasse</v-card-title>
                        <v-card-text>
                            <div class="text-h4 text--primary">
                                {{ applicationSetting.lastBundleMillesim }}
                            </div>
                        </v-card-text>
                    </v-card> -->
                </v-col>
                <v-col cols="6" class="pa-2">
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Déclarations fiscales</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-center">
                            <v-btn
                                size="small"
                                dark
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                color="primary"
                                @click="generateTaxForms2(2025)"
                            >
                                Déclarations 2025 - Générer les formulaires
                            </v-btn>
                            <v-btn
                                size="small"
                                dark
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                color="primary"
                                @click="generateTaxForms2(2024)"
                            >
                                Déclarations 2024 - Générer les formulaires
                            </v-btn>
                            <!-- <v-btn
                                disabled
                                size="small"
                                dark
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                color="primary"
                                @click="generateTaxForms()"
                            >
                                Générer les formulaires (fichiers Bobbee)
                            </v-btn> -->
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pa-2">
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Liasses fiscales</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-center">
                            <v-btn
                                size="small"
                                dark
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                color="primary"
                                @click="generateBundleTaxForms(2025)"
                            >
                                Liasses 2025 - Générer les formulaires
                            </v-btn>
                            <v-btn
                                size="small"
                                dark
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                color="primary"
                                @click="generateBundleTaxForms(2024)"
                            >
                                Liasses 2024 - Générer les formulaires
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pa-2">
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Révision</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-center">
                            <v-btn
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                @click="generateAuditChecks()"
                                size="small"
                            >
                                Générer les contrôles
                            </v-btn>
                            <v-btn
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                @click="generateAccountingReviewLayouts()"
                                size="small"
                            >
                                Générer les dossiers de révision
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pa-2">
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Metrics/KPIs</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-center">
                            <v-row class="d-flex justify-center align-center">
                                <v-col cols="4" />
                                <v-col cols="4">
                                    <p class="text--primary">Clients</p>
                                </v-col>
                                <v-col cols="4">
                                    <p class="text--primary">Dossiers</p>
                                </v-col>
                                <v-col cols="4">
                                    <p class="text--primary">Expert</p>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.expertClientsCount }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.expertFilesCount }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <p class="text--primary">Business</p>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.businessClientsCount }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.businessFilesCount }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <p class="text--primary">Totaux</p>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.allClientsCount }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-h4 text--primary">
                                        {{ kpis.allFilesCount }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pa-2" v-if="localEnv !== 'production'">
                    <v-card class="rounded-xl fill-height" elevation="0">
                        <v-card-title>Suivi d'apprentissage</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-center">
                            <v-btn
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                @click="syncTutorials()"
                                size="small"
                            >
                                Synchroniser les tutoriels
                            </v-btn>
                            <v-btn
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                @click="syncModules()"
                                size="small"
                            >
                                Synchroniser les modules
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="4" class="pa-2">
            <!-- Centre de controle -->
            <v-card class="rounded-xl fill-height" elevation="0">
                <v-card-title>Centre de contrôle</v-card-title>
                <v-card-text>
                    <v-list nav dense>
                        <v-list-item
                            class="oss-list-item"
                            @click="maintenance()"
                            :model-value="'maintenance'"
                        >
                            <v-list-item-icon>
                                <v-icon color="primary">$fa-wrench</v-icon>
                            </v-list-item-icon>
                            {{
                                applicationSetting.maintenance
                                    ? "Arreter la maintenance"
                                    : "Mettre bobbee en maintenance"
                            }}
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import UPSERT_MAINTENANCE from "../../graphql/controlCenter/Maintenance.gql";
import APPLICATION_SETTING from "../../graphql/controlCenter/ApplicationSetting.gql";
import GENERATE_TAX_FORMS from "../../graphql/controlCenter/GenerateTaxForms.gql";
import GENERATE_TAX_FORMS_2 from "../../graphql/controlCenter/GenerateTaxForms2.gql";
import GENERATE_BUNDLE_TAX_FORMS from "../../graphql/controlCenter/GenerateBundleTaxForms.gql";
import UPDATE_AUDIT_CHECKS from "../../graphql/audit/updateAuditChecks.gql";
import UPDATE_ACCOUNTING_REVIEW_LAYOUTS from "../../graphql/controlCenter/UpdateAccountingReviewLayouts.gql";
import SYNC_TUTORIALS from "../../graphql/tutorials/SyncTutorials.gql";
import SYNC_MODULES from "../../graphql/tutorials/SyncTutorialsModules.gql";
import APPLICATION_KPIS from "../../graphql/controlCenter/ApplicationKpis.gql";
import getEnv from "../../env";
import { Component, Vue, toNative } from "vue-facing-decorator";

const env = getEnv();

const logoBobbeeMini = require("../../assets/img/bobbee_mini.png");

@Component
export class ControlCenterDashboard extends Vue {
    localEnv = env.environnement;

    async maintenance() {
        debugger;
        try {
            await this.$apollo.mutate({
                mutation: UPSERT_MAINTENANCE,
            });
            this.applicationSetting.maintenance = !this.applicationSetting.maintenance;
        } catch (error) {
            console.error(error);
        }
    }

    async generateBundleTaxForms(year: number) {
        try {
            await this.$apollo.mutate({
                mutation: GENERATE_BUNDLE_TAX_FORMS,
                variables: {
                    year,
                },
            });
        } catch (error) {
            console.error(error);
        }
    }

    async generateTaxForms() {
        try {
            await this.$apollo.mutate({
                mutation: GENERATE_TAX_FORMS,
            });
        } catch (error) {
            console.error(error);
        }
    }

    async generateTaxForms2(year: number) {
        try {
            await this.$apollo.mutate({
                mutation: GENERATE_TAX_FORMS_2,
                variables: {
                    year,
                },
            });
        } catch (error) {
            console.error(error);
        }
    }

    async generateAuditChecks() {
        try {
            await this.$apollo.mutate({
                mutation: UPDATE_AUDIT_CHECKS,
            });
        } catch (error) {
            console.error(error);
        }
    }

    async generateAccountingReviewLayouts() {
        try {
            await this.$apollo.mutate({
                mutation: UPDATE_ACCOUNTING_REVIEW_LAYOUTS,
            });
        } catch (error) {
            console.error(error);
        }
    }

    async syncTutorials() {
        try {
            await this.$apollo.mutate({
                mutation: SYNC_TUTORIALS,
            });
        } catch (error) {
            console.error(error);
        }
    }

    async syncModules() {
        try {
            await this.$apollo.mutate({
                mutation: SYNC_MODULES,
            });
        } catch (error) {
            console.error(error);
        }
    }

    get selected() {
        let result = [];
        if (this.applicationSetting.maintenance) {
            result.push("maintenance");
        }
        return result;
    }

    set selected(value) {
        debugger;
    }

    @Apollo({
        query: APPLICATION_KPIS,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                const {
                    allClientsCount,
                    allFilesCount,
                    businessClientsCount,
                    businessFilesCount,
                    expertClientsCount,
                    expertFilesCount,
                } = data.applicationKpis;

                this.kpis = {
                    allClientsCount,
                    allFilesCount,
                    businessClientsCount,
                    businessFilesCount,
                    expertClientsCount,
                    expertFilesCount,
                };
            }
        },
    })
    kpis = {
        allClientsCount: 0,
        allFilesCount: 0,
        businessClientsCount: 0,
        businessFilesCount: 0,
        expertClientsCount: 0,
        expertFilesCount: 0,
    };

    @Apollo({
        query: APPLICATION_SETTING,
    })
    applicationSetting = {
        maintenance: false,
        // lastBundleMillesim: "2023",
    };
}

export default toNative(ControlCenterDashboard);
</script>
